import GeolocationAPI from '../geolocation';
import { HIDDEN } from '../classnames/design-system';
import { COOKIE_BANNER_IS_VISIBLE } from '../classnames/third-party-buttons';
import { BANNER_VISIBILITY_TIMEOUT, IS_BANNER_VISIBLE, SELECTORS } from './constants';

export class CookieBanner {
  constructor() {
    this.geolocation = new GeolocationAPI();
    this.banner = document.querySelector(`.${SELECTORS.COOKIE_BANNER}`);
    this.closeBtn = document.querySelector(`.${SELECTORS.CLOSE_BTN}`);
    this.isVisible = localStorage.getItem(IS_BANNER_VISIBLE) !== 'false';
  }

  handleOpen = () => {
    this.banner.classList.remove(HIDDEN);
    document.body.classList.add(COOKIE_BANNER_IS_VISIBLE);
  };

  handleClose = () => {
    this.banner.classList.add(HIDDEN);
    document.body.classList.remove(COOKIE_BANNER_IS_VISIBLE);
    localStorage.setItem(IS_BANNER_VISIBLE, false);
  };

  initializeEventListeners = () => {
    this.closeBtn.addEventListener('click', this.handleClose);

    window.addEventListener('load', () => {
      setTimeout(this.handleClose, BANNER_VISIBILITY_TIMEOUT);
    });
  };

  init = () => {
    this.geolocation.detectCurrentLocation().then((location) => {
      const currentCountryCode = location.countryCode;
      const countryCodes = ['US', 'AU', 'CA'];
      const isAvailableCountry = countryCodes.includes(currentCountryCode);

      if (this.isVisible && isAvailableCountry) {
        this.handleOpen();
        this.initializeEventListeners();
      }
    });
  };
}
